import { createContext, FC, ReactNode, useContext, useMemo } from "react";

import { useGetAllConfListsQuery } from "src/graphql/anti-fraud/queries/confLists/GetAllConfListsQuery";
import { ConfList } from "src/types/confList";

type ConfListsContextValue = {
  confLists: ConfList[];
};

const ConfListsContext = createContext<ConfListsContextValue>({
  confLists: [],
});

export const ConfListsProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const { data: confLists } = useGetAllConfListsQuery();

  const contextValue = useMemo<ConfListsContextValue>(
    () => ({ confLists: (confLists as ConfList[] | undefined) ?? [] }),
    [confLists]
  );

  return <ConfListsContext.Provider value={contextValue}>{children}</ConfListsContext.Provider>;
};

export const useConfLists = (): ConfList[] => {
  return useContext(ConfListsContext).confLists;
};

export const useConfList = (code: string): ConfList | undefined => {
  return useContext(ConfListsContext).confLists.find((cl) => cl.code === code);
};
